import { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TEMP, PERM } from "../components/employer/TempReports/constants";

// Provide previous props
export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useDebouncedValue = (inputValue, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, delay]);

  return debouncedValue;
};

export const useUrlScope = () => {
  const location = useLocation();
  const isContingentContext = location.pathname.includes("/contingent/");

  return isContingentContext ? TEMP : PERM;
};
